module.exports = __webpack_public_path__ + "static/media/Desktop8.72251a46.jpg";